import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=314ed18e&scoped=true"
import script from "./ClockIcon.vue?vue&type=script&lang=js"
export * from "./ClockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314ed18e",
  null
  
)

export default component.exports